import React from 'react';
import PropTypes from 'prop-types';

import s from './RadioLine.module.css';

const RadioLine = React.memo(({ items, selected, itemWidth }) => {
  const selectedItem = items.find(({ value }) => value === selected);
  const selectedIndex = items.indexOf(selectedItem);
  return (
    <div className={s.root}>
      {selectedItem && (
        <button
          className={s.selection}
          style={{ width: `${itemWidth}px`, left: `${(5 + itemWidth) * selectedIndex}px` }}
        >
          {selectedItem.label}
        </button>
      )}
      {items.map(({ onClick, label, value }, index) => (
        <button key={index} onClick={onClick} className={s.option} style={{ width: `${itemWidth}px` }}>
          {label}
        </button>
      ))}
    </div>
  );
});

RadioLine.propTypes = {
  itemWidth: PropTypes.number,
  selected: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

RadioLine.defaultProps = {
  itemWidth: 100,
};

export default RadioLine;
